<template>
  <div>
    <vue-snotify></vue-snotify>
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"
    ></loading>
    <div class="content-height">
      <b-card>
        <b-row align-v="center" slot="header">
          <b-col cols="8">
            <h3 class="mb-0">Projects</h3>
          </b-col>

          <b-col lg="4">
            <b-button
              variant="primary"
              id="show-btn"
              @click="
                $bvModal.show('bv-modal-example-2');
                resetProjectForm();
              "
              class="float-right"
              :disabled="projectBtnDisableCondition"
            >
              <i class="fa-solid fa-plus"></i>
              Add New Project</b-button
            >
            <b-button
              @click="publishProject()"
              v-if="
                projects.length != 0 &&
                activeClaim &&
                !activeClaim.isProjectsPublished
              "
              class="float-right mr-2"
              variant="warning"
              :disabled="projectBtnDisableCondition"
            >
              Update
            </b-button>
          </b-col>
        </b-row>

        <b-row v-for="(project, index) in projects" :key="project.id">
          <b-col lg="4">
            <div class="form-group">
              <label class="form-control-label">Project Name</label>
              <b-input
                :value="project.name"
                type="text"
                :title="project.name"
                disabled
                placeholder="Enter Your Name"
              >
              </b-input>
            </div>
          </b-col>
          <b-col lg="3">
            <div class="form-group">
              <label class="form-control-label">Start Date</label>
              <b-input :value="convertDate(project.startDate)" disabled>
              </b-input>
            </div>
          </b-col>
          <b-col lg="3">
            <div class="form-group">
              <label class="form-control-label">End Date</label>
              <b-input :value="convertDate(project.endDate)" disabled>
              </b-input>
            </div>
          </b-col>
          <!-- <b-col lg="2">
            <div class="pt-lg-4 mt-lg-2">
              <b-button variant="outline-primary" v-show="false">
                <i class="fa-solid fa-trash-can"></i>
              </b-button>
            </div>
          </b-col> -->
          <b-col lg="2">
            <div class="pt-lg-4 mt-lg-2">
              <b-button
                variant="outline-primary"
                title="Edit Project"
                @click="editProject(project)"
              >
                <i class="fa-solid fa-pencil"></i>
              </b-button>
            </div>
          </b-col>
        </b-row>

        <b-row>
          <b-col lg="12">
            <div v-if="projects.length == 0">No data available</div>
          </b-col>
        </b-row>
      </b-card>

      <!-- Start New Project Model -->

      <b-modal id="bv-modal-example-2" hide-footer>
        <template #modal-title>
          <h3 v-if="actionMode == 'Create'">{{ actionMode }} New Project</h3>
          <h3 v-if="actionMode == 'Update'">{{ actionMode }} Project</h3>
        </template>
        <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
          <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
            <div class="d-block">
              <b-row>
                <b-col cols="12">
                  <div class="form-group">
                    <label class="form-control-label">Project Name (*)</label>
                    <b-form-group label="Project Description">
                      <b-form-textarea
                        v-model="project_name"
                        rows="3"
                        max-rows="6"
                        placeholder="Enter your project description"
                        :state="projectNameState"
                        @blur="validateProjectName">
                      </b-form-textarea>
                      <b-form-invalid-feedback v-if="!isValidProjectName">
                        {{projectNameErrorMessage}}
                      </b-form-invalid-feedback>
                    </b-form-group>
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label">Start Date</label>
                    <base-input
                      v-model="start_date"
                      type="date"
                      name="Start Date"
                    >
                    </base-input>
                  </div>
                </b-col>
                <b-col lg="12">
                  <div class="form-group">
                    <label class="form-control-label">End Date</label>
                    <base-input v-model="end_date" type="date" name="End Date">
                    </base-input>
                  </div>
                </b-col>
              </b-row>
            </div>

            <div class="float-right mt-3">
              <base-button type="primary" native-type="submit">{{
                actionMode
              }}</base-button>
              <b-button variant="" @click="$bvModal.hide('bv-modal-example-2')"
                >Cancel</b-button
              >
            </div>
          </b-form>
        </validation-observer>
      </b-modal>
      <!-- End Checklist Model -->
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import moment from "moment";
import mixins from "./../../mixins/common.js";

export default {
  data() {
    return {
      projects: [],
      project_name: "",
      start_date: "",
      end_date: "",
      isLoading: false,
      fullPage: true,
      actionMode: "Create",
      activeProjectId: "",
      isValidProjectName: true,
      projectNameErrorMessage: ""
    };
  },
  mixins: [mixins],
  props: ["claim_id", "client_id"],
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
  },
  watch: {
    claim_id: function (newVal, oldVal) {
      this.loadProjects();
    },
  },
  methods: {
    ...mapActions("admin", [
      "getClaimProjects",
      "createNewClaimProject",
      "updateClaimProject",
      "publishAllProjects",
      "getClaimRecordById",
    ]),
    refreshClaimSpecificData() {
      let claimParams = {
        claim_id: this.claim_id,
      };
      if (this.claim_id) {
        this.getClaimRecordById(claimParams).then((data) => {
          if (data && data.data) {
            this.cs_upadte_str = this.updateByCsStr(
              data.data.csUpdateBy,
              data.data.csUpdatedOn
            );
            this.tr_upadte_str = this.updateByTrStr(
              data.data.trUpdateBy,
              data.data.trUpdatedOn
            );
          } else {
          }
          this.isLoading = false;
        });
      }
    },
    publishProject() {
      this.isLoading = true;
      let projectParams = {
        claim_id: this.claim_id,
      };

      this.publishAllProjects(projectParams).then((data) => {
        if (data.data && data.data.success) {
          this.$snotify
            .success(data.data.success.message, "Success!", {
              position: "centerTop",
            })
            .on("destroyed", () => {});
          this.activeClaim.isProjectsPublished = true;
          this.refreshClaimSpecificData();
        } else {
        }
        this.isLoading = false;
      });
    },
    convertDate(date) {
      if (date) {
        let dateStr = moment(new Date(date)).format("YYYY-MM-DD");
        if (dateStr != "0001-01-01") {
          return dateStr;
        } else {
          return "N/A";
        }
      } else {
        return "N/A";
      }
    },
    resetProjectForm() {
      this.project_name = "";
      this.start_date = "";
      this.end_date = "";
      this.actionMode = "Create";
      this.activeProjectId = "";
      this.projectNameErrorMessage = "";
      this.isValidProjectName = true;
    },
    onSubmit() {
      this.validateProjectName();
      if(!this.isValidProjectName) return;

      this.isLoading = true;
      let projectParams = {
        name: this.project_name,
        claim_id: this.claim_id,
      };

      if (this.end_date) {
        projectParams.endDate = this.end_date;
      }
      if (this.start_date) {
        projectParams.startDate = this.start_date;
      }

      if (this.activeProjectId) {
        projectParams.id = this.activeProjectId;
      }

      if (this.actionMode == "Create") {
        this.createNewClaimProject(projectParams).then((data) => {
          if (data.data.errors) {
            this.$refs.formValidator.setErrors(data.data.errors);
          } else {
            this.loadProjects();
            this.$bvModal.hide("bv-modal-example-2");
            this.$snotify
              .success(data.data.message, "Success!", {
                position: "centerTop",
              })
              .on("destroyed", () => {});
            this.activeClaim.isProjectsPublished = false;
          }
          this.isLoading = false;
        });
      } else {
        this.updateClaimProject(projectParams).then((data) => {
          if (data.data.errors) {
            this.$refs.formValidator.setErrors(data.data.errors);
          } else {
            this.loadProjects();
            this.$bvModal.hide("bv-modal-example-2");
            if (data.data && data.data.success && data.data.success.message) {
              this.$snotify
                .success(data.data.success.message, "Success!", {
                  position: "centerTop",
                })
                .on("destroyed", () => {});
              this.activeClaim.isProjectsPublished = false;
            }
          }
          this.isLoading = false;
        });
      }
    },
    loadProjects() {
      if (this.claim_id) {
        let projectParams = {
          claim_id: this.claim_id,
        };
        this.getClaimProjects(projectParams).then((data) => {
          if (data.data.errors) {
          } else {
            this.projects = data.data;
          }
        });
      } else {
        this.projects = [];
      }
    },
    editProject(project) {
      this.actionMode = "Update";
      this.$bvModal.show("bv-modal-example-2");
      this.activeProjectId = project.id;
      this.project_name = project.name;
      this.projectNameErrorMessage = "";
      this.isValidProjectName = true;
      this.start_date = this.convertDateValues(project.startDate);
      this.end_date = this.convertDateValues(project.endDate);
    },
    validateProjectName() {
      if (!this.project_name) {
        this.projectNameErrorMessage = "The Project Name field is required"
        this.isValidProjectName = false;
      } else if(this.project_name.length > 250){
        this.projectNameErrorMessage = "The Project Name cannot exceed 250 characters"
        this.isValidProjectName = false;
      } else {
        this.isValidProjectName = true;
      }
    },
  },
  computed: {
    projectNameState() {
      return this.isValidProjectName ? true : false;
    },
    projectBtnDisableCondition() {
      let disableCheck = false;
      if (
        !this.claim_id ||
        !this.client_id ||
        (this.activeClaim && this.activeClaim.internalReviewStatus == 5) ||
        (this.activeClaim && !this.activeClaim.industryType) ||
        (this.activeClaim && !this.activeClaim.proxy) ||
        (!this.checkIfClaimHasPermission(this.activeClaim))
      ) {
        disableCheck = true;
      }
      return disableCheck;
    },
    tr_upadte_str: {
      get() {
        return this.$store.state.admin.tr_upadte_str;
      },
      set(val) {
        this.$store.state.admin.tr_upadte_str = val;
      },
    },
    cs_upadte_str: {
      get() {
        return this.$store.state.admin.cs_upadte_str;
      },
      set(val) {
        this.$store.state.admin.cs_upadte_str = val;
      },
    },
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
  },
};
</script>

<style scoped>
.was-validated .form-control:invalid, .form-control.is-invalid, .was-validated .custom-select:invalid, .custom-select.is-invalid{
  border-color: red;
}
</style>
